export * from './table/table.component';
export * from './table-wrap/table-wrap.component';
export * from './tables/tables.component';
export * from './cell/cell.component';
export * from './tables.module';
